/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmVectorStoresGet } from "../../funcs/llmVectorStoresGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetVectorStoreRequest$inboundSchema,
};

export const tool$llmVectorStoresGet: ToolDefinition<typeof args> = {
  name: "llm-vector-stores-get",
  description: `Retrieve a vector store

Retrieves a vector store by its ID.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmVectorStoresGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
